import MaterialBox, { BoxProps } from "@mui/material/Box";

const Box = (props: BoxProps & { children?: any; style?: React.CSSProperties }) => <MaterialBox display="flex" boxSizing="border-box" {...props} />;

export { Box };
